<template>
  <DefaultLayout>
    <div slot="content">

      <div class="d-flex align-center py-3">
        <div class="title">Vaults | Total: {{ userStores.length }}</div>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Search" hide-details class="mt-0 mr-3"></v-text-field>
      </div>
      <v-divider></v-divider>

      <div class="d-flex align-center py-0">
        <v-switch inset @change="updateSwitch" v-model="onlyExpired" label="Show only expired"></v-switch>
        <v-spacer></v-spacer>
        <v-btn :disabled="selected.length === 0" @click="removeStores" depressed color="error" class="mr-1">Remove stores now</v-btn>
        <v-btn :disabled="selected.length === 0" @click="sendReminder" depressed color="primary" class="mr-1">Send expire reminder</v-btn>
        <v-btn :disabled="selected.length === 0" @click="renewSubs" depressed color="primary">Renew subscription and stop expiration/deletion</v-btn>        
      </div>

      <v-data-table v-if="userStores" :headers="headers"
                    :loading="dataLoading"
                    :items="userStores"
                    v-model="selected"
                    :search="search"
                    show-select
                    :footer-props="{
                      itemsPerPageOptions: [10, 20, 50, { text: 'All', value: -1 }],
                      showFirstLastPage: false,
                      prevIcon: 'fal fa-chevron-left',
                      nextIcon: 'fal fa-chevron-right',
                      itemsPerPageText: 'Accounts per page'
                    }"
                    :hide-default-footer="userStores && userStores.length < 11">
        <template v-slot:top="{ pagination, options, updateOptions }">
          <v-data-footer 
            :pagination="pagination" 
            :options="options"
            :itemsPerPageOptions="[10, 20, 50, { text: 'All', value: -1 }]"
            :showFirstLastPage="false"
            prevIcon="fal fa-chevron-left"
            nextIcon="fal fa-chevron-right"
            @update:options="updateOptions"
            items-per-page-text="Accounts per page" />
        </template>
        <template v-slot:item.dateCreated="{ item }">
          <div style="height:100%; padding:13px 5px 10px 15px;">
            <span>{{ formatDate(item.dateCreated) }}</span>
          </div>
        </template>
        <template v-slot:item.dateUpdated="{ item }">
          <div style="height:100%; padding:13px 5px 10px 15px;">
            <span>{{ formatDate(item.dateUpdated) }}</span>
          </div>
        </template>
        <template v-slot:item.lastPaymentDate="{ item }">
          <div style="height:100%; padding:13px 5px 10px 15px;">
            <span v-if="formatDate(item.lastPaymentDate) === '01/01/1, 00:00:00'">NONE</span>
            <span v-else>{{ formatDate(item.lastPaymentDate) }}</span>
          </div>
        </template>
        <template v-slot:item.expireInProgress="{ item }">
          <div style="height:100%; padding:13px 5px 10px 15px;" :class="getRowColor(item.expireInProgress)">
            <span v-if="item.expireInProgress">YES</span>
            <span v-else>NO</span>
          </div>
        </template>
        <template v-slot:item.removalInProgress="{ item }">
          <div style="height:100%; padding:13px 5px 10px 15px;" :class="getRowColor(item.removalInProgress)">
            <span v-if="item.removalInProgress">YES</span>
            <span v-else>NO</span>
          </div>
        </template>  
      </v-data-table>


    </div>
  </DefaultLayout>
</template>

<script>
import DefaultLayout from '@/layouts/DefaultLayout';
import { GET_USER_STORES_EXPIRE, GET_USER_STORES_ALL, UPDATE_USER_STORES, REMOVE_USER_STORES, REMIND_USER_STORES } from '@/store/actions.type';


export default {
  name: '',
  components: {
    DefaultLayout,
  },
  data() {
    return {
      userStores: [],
      headers: [
        { text: 'Email', value: 'userEmail', align: 'left' },
        { text: 'Created', value: 'dateCreated', align: 'left' },
        { text: 'Updated', value: 'dateUpdated', align: 'left' },
        { text: 'Last payment date', value: 'lastPaymentDate', align: 'left' },
        { text: 'Expire in progress', value: 'expireInProgress', align: 'left' },
        { text: 'Removal in progress', value: 'removalInProgress', align: 'left' },
      ],
      dataLoading: false,
      search: '',
      onlyExpired: true,
      selected: []
    };
  },
  methods: {
    async removeStores(){
      if (confirm('Remove selected user vaults?')) {
        const storeIds = [];
        this.selected.forEach(st => storeIds.push(st.id));
        await this.$store.dispatch(REMOVE_USER_STORES, { storeId: storeIds });
        if(this.onlyExpired){
          this.getExpired();
        }else{
          this.getAll();
        }
      }
    },
    async sendReminder(){
      if (confirm('Send reminders?')) {
        const storeIds = [];
        this.selected.forEach(st => storeIds.push(st.id));
        await this.$store.dispatch(REMIND_USER_STORES, { storeId: storeIds });
      }
    },
    async getExpired(){
      this.dataLoading = true;
      const response = await this.$store.dispatch(GET_USER_STORES_EXPIRE);
      if(response.list && response.list.length > 0){
        this.userStores = response.list;
      }
      else{
        this.userStores = [];
      }
      this.dataLoading = false;
    },
    async getAll(){
      this.dataLoading = true;
      const response = await this.$store.dispatch(GET_USER_STORES_ALL);
      if(response.list && response.list.length > 0){
        this.userStores = response.list;
      }
      else{
        this.userStores = [];
      }
      this.dataLoading = false;
    },
    formatDate(date){
      return new Date(date).toLocaleString('en-GB', { timeZone: 'UTC' });
    },    
    getRowColor(par){
      if(par){
        return 'rowred'  
      }
      return 'rowgreen'
    },
    updateSwitch(){
      if(this.onlyExpired){
        this.getExpired();
      }else{
        this.getAll();
      }
    },
    async renewSubs(){
      if (confirm('Renew subscriptions for selected stores?')) {
        const storeIds = [];
        this.selected.forEach(st => storeIds.push(st.id));
        await this.$store.dispatch(UPDATE_USER_STORES, { storeId: storeIds });
        if(this.onlyExpired){
          this.getExpired();
        }else{
          this.getAll();
        }
      }
    }
  },
  mounted () {
    if(this.onlyExpired){
      this.getExpired();
    }else{
      this.getAll();
    }
  },
}
</script>

<style>
.rowgreen {
  background-color: #AEFFBD;
}
.rowred {
  background-color: #FF9191;
}
</style>